var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd-section",attrs:{"id":"features"}},[_c('Feature1'),_c('Feature2'),_c('Feature3'),_c('Feature4'),_c('Feature5'),_c('Feature6'),_c('Feature7')],1)}
var staticRenderFns = []

export { render, staticRenderFns }